import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowRight, RefreshCw, MessageCircle } from 'lucide-react';

export const PaymentFailurePage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-24" data-testid="payment-failure-page">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="glass-card p-12 max-w-lg w-full text-center"
      >
        {/* Error Animation */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', duration: 0.5 }}
          className="w-24 h-24 mx-auto mb-8 rounded-full bg-red-500/20 flex items-center justify-center"
        >
          <XCircle className="w-12 h-12 text-red-400" />
        </motion.div>

        <h1 className="text-3xl font-bold mb-4">Payment Unsuccessful</h1>
        <p className="text-white/60 mb-8">
          We couldn't process your payment. This could be due to insufficient funds, 
          an expired card, or a temporary issue with your payment provider.
        </p>

        {/* Troubleshooting Tips */}
        <div className="bg-white/5 rounded-xl p-6 mb-8 text-left">
          <h3 className="font-semibold mb-4">What you can try:</h3>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-3">
              <span className="w-5 h-5 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0 text-xs">1</span>
              <span>Check your card details and try again</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-5 h-5 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0 text-xs">2</span>
              <span>Use a different payment method</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-5 h-5 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0 text-xs">3</span>
              <span>Contact your bank if the issue persists</span>
            </li>
          </ul>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/pricing"
            className="px-8 py-4 bg-[#00D4FF] text-black font-semibold rounded-full hover:shadow-[0_0_30px_rgba(0,230,118,0.4)] transition-all flex items-center justify-center gap-2"
            data-testid="retry-payment"
          >
            <RefreshCw className="w-5 h-5" />
            Try Again
          </Link>
          <a
            href="https://wa.me/+918055082222?text=Hi,%20I%20had%20an%20issue%20with%20my%20payment"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-4 text-white font-medium rounded-full border border-white/20 hover:bg-white/5 transition-all flex items-center justify-center gap-2"
            data-testid="contact-support"
          >
            <MessageCircle className="w-5 h-5" />
            Contact Support
          </a>
        </div>

        {/* Additional Help */}
        <p className="text-white/40 text-sm mt-8">
          Error code: PAYMENT_FAILED • Reference will be sent to your email
        </p>
      </motion.div>
    </div>
  );
};

export default PaymentFailurePage;
